export function calculatorArticleHead({
  canonical,
  headline,
  description,
  dateModified = "2026-09-30",
}: {
  canonical: string;
  headline: string;
  description: string;
  dateModified?: string;
}) {
  return {
    links: [{ rel: "canonical", href: canonical }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          headline,
          description,
          author: {
            "@type": "Organization",
            name: "AtalayTheCoach",
            url: "https://atalaythecoach.com",
          },
          publisher: {
            "@type": "Organization",
            name: "AtalayTheCoach",
            url: "https://atalaythecoach.com",
          },
          dateModified,
          inLanguage: "tr-TR",
          mainEntityOfPage: canonical,
        }),
      },
    ],
  };
}
